module.exports = __webpack_public_path__ + "static/media/USLUGA4.8ebcbc3e.jpeg";